module.exports = __webpack_public_path__ + "img/04ecc14bacb19b7532e9cbfd53c0cd56.04ecc14b.png";